<template>
  <div>
    <div class="d-flex mt-16">
      <div>
        <div class="text-5 font-weight-medium">Stake Amount</div>
        <div class="d-flex align-center mt-2 text-2">
          <div>
            <span class="primary--text">{{
              txPayload.amount | denomFormat
            }}</span>
            <span class="gray--text text-uppercase ml-1">{{
              currentProject.staking.token
            }}</span>
          </div>
          <img
            :src="
              ($vuetify.theme.dark
                ? currentProject.logoSmallDark
                : currentProject.logoSmall) || currentProject.logoSmall
            "
            height="36"
            width="36"
            class="ml-4"
          />
        </div>
        <div class="mt-2 gray--text text-5">${{ stakeValue | currency }}</div>
      </div>
    </div>
    <div class="mt-16">
      <c-btn class="width-100" @click="confirm">Confirm</c-btn>
    </div>
    <tx-solana
      v-if="showTxModal"
      title="Stake"
      name="Delegate"
      successMesssage="Transaction sent"
      broadcastAction="staking/solana/createTx"
      :getRawTx="getRawTx"
      :metadata="{ amount: txPayload.amount }"
      @cancel="showTxModal = false"
      @onSuccess="onTxSuccess"
    >
    </tx-solana>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    txPayload: Object,
  },
  data: () => ({
    showTxModal: false,
  }),
  computed: {
    ...mapGetters({
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
      currentProject: "projectConfig/latestProject",
    }),
    stakeValue() {
      return (
        this.getTokenPriceInUsd(this.currentProject.staking.token) *
        this.txPayload.amount
      );
    },
  },
  methods: {
    async getRawTx() {
      return this.$store.dispatch("staking/solana/getStakeRawTx", {
        amount: this.txPayload.amount,
      });
    },
    confirm() {
      this.showTxModal = true;
    },
    async onTxSuccess() {
      this.showTxModal = false;
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
      });
      this.$emit("close");
    },
  },
};
</script>
